export default function EnvelopeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_841)">
        <path
          d="M15.7494 13.7246H2.24941C1.50489 13.7246 0.899414 13.1191 0.899414 12.3746V4.94961C0.899414 4.20576 1.50489 3.59961 2.24941 3.59961H15.7494C16.4939 3.59961 17.0994 4.20576 17.0994 4.94961V12.3746C17.0994 13.1191 16.4939 13.7246 15.7494 13.7246ZM2.24941 4.94961V12.3746H15.7501L15.7494 4.94961H2.24941Z"
          fill="black"
        />
        <path
          d="M3.59961 7.64941H8.99961V8.99941H3.59961V7.64941Z"
          fill="black"
        />
        <path
          d="M3.59961 9.6748H8.99961V11.0248H3.59961V9.6748Z"
          fill="black"
        />
        <path d="M11.6992 5.625H14.3992V8.325H11.6992V5.625Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_0_841">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
